import styled from "styled-components";

import TestingChannelsTable from "./TestingChannelsTable";
import TestingAudiences from "./TestingAudiences";
import EytvProperties from "./EytvProperties";
import TestingYoutubeProperties from "./TestingYoutubeProperties";
import YoutubeThumbsProperties from "./YoutubeThumbsProperties";
import YoutubeClipsProperties from "./YoutubeClipsProperties";
import YoutubeSequencesProperties from "./YoutubeSequencesProperties";
import YoutubeFinalisationProperties from "./YoutubeFinalisationProperties";

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 24px;
`;

export const FormLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
`;

export const HeadingRow = styled.div`
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const YoutubeProperties = () => {
  return (
    <>
      <TestingChannelsTable />
      <TestingAudiences />
      <TestingYoutubeProperties />
      <EytvProperties />
      <YoutubeThumbsProperties />
      <YoutubeClipsProperties />
      <YoutubeSequencesProperties />
      <YoutubeFinalisationProperties />
    </>
  );
};

export default YoutubeProperties;
